import type { BarberService } from '@/types';
import './ServiceCard.css';

interface ServiceCardProps {
  service: BarberService;
  selected: boolean;
  onSelect: (id: string) => void;
}

export default function ServiceCard({ service, selected, onSelect }: ServiceCardProps) {
  return (
    <button
      type="button"
      onClick={() => onSelect(service.id)}
      className={`service-card-btn ${selected ? 'service-card-btn--selected' : ''}`}
    >
      <div className="service-card-header">
        <span className="service-card-name">{service.name}</span>
        <span className="service-card-price">
          {service.currency}{service.price}
        </span>
      </div>

      {service.description && (
        <p className="service-card-description">{service.description}</p>
      )}

      <div className="service-card-meta">
        <span className="service-card-duration">
          <i className="ri-time-line" />
          {service.duration} min
        </span>
        {selected && (
          <span className="service-card-selected-badge">
            <i className="ri-check-double-line" /> Seleccionado
          </span>
        )}
      </div>
    </button>
  );
}